export const WHALY_LINK = {
  POINTS_OF_SALE: 'point-de-vente',
  SECTORS: 'secteurs-cfk0of8'
}